module.exports = __webpack_public_path__ + "static/media/cupon.5af61a41.svg";